import React from 'react';
import { ShieldCheck, ShieldAlert } from 'lucide-react';

const Stat = ({ icon: Icon, label, value, detail, tone, testId }) => (
  <div className={`flex-1 rounded-lg border p-2 ${tone}`} data-testid={testId}>
    <div className="flex items-center gap-1 text-xs font-semibold">
      <Icon className="w-3.5 h-3.5" /> {label}
    </div>
    <p className="text-xl font-bold leading-tight">{value === null || value === undefined ? '--' : `${value}%`}</p>
    <p className="text-[11px]">{detail}</p>
  </div>
);

export const OrderScorecard = ({ card }) => {
  if (!card) return null;
  return (
    <div className="mb-4" data-testid="order-review-scorecard">
      <p className="text-xs font-semibold text-slate-700 mb-1">
        Your order review scorecard ({card.reviews} {card.reviews === 1 ? 'review' : 'reviews'})
      </p>
      <div className="flex gap-2">
        <Stat
          icon={ShieldCheck}
          label="Unsafe orders caught"
          value={card.catch_rate}
          detail={`${card.unsafe_caught} of ${card.unsafe_total} flagged`}
          tone="bg-emerald-50 border-emerald-200 text-emerald-900"
          testId="scorecard-catch-rate"
        />
        <Stat
          icon={ShieldAlert}
          label="Safe orders over-flagged"
          value={card.overflag_rate}
          detail={`${card.safe_overflagged} of ${card.safe_total} flagged`}
          tone="bg-amber-50 border-amber-200 text-amber-900"
          testId="scorecard-overflag-rate"
        />
      </div>
    </div>
  );
};
